import React, { Component } from "react";
import { Route, Switch } from 'react-router-dom';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Layout from "./components/layout/Layout";

import LoginPage from "./components/pages/LoginPage/LoginPage";

//Клиенты и консультанты
import ClientsList from "./components/pages/ClientsList/ClientsList";
import ConsultantsList from "./components/pages/ConsultantsList/ConsultantsList";
import ConsultantInfo from "./components/pages/ConsultantInfo/ConsultantInfo";

//Опросы
import PollsList from "./components/pages/PollsList/PollsList";
import PollInfo from "./components/pages/PollInfo/PollInfo";
import CreatePoll from "./components/pages/CreatePoll/CreatePoll";
import EditPoll from "./components/pages/EditPoll/EditPoll";

//Шаблоны визиток
import TemplatesList from "./components/pages/TemplatesList/TemplatesList";
import TemplateInfo from "./components/pages/TemplateInfo/TemplateInfo";
import CreateTemplate from "./components/pages/CreateTemplate/CreateTemplate";
import EditTemplate from "./components/pages/EditTemplate/EditTemplate";

//Аналитика
import Analytics from "./components/pages/Analytics/Analytics";

//Разблокировка телефонов
import BlockedPhones from "./components/pages/BlockedPhones/BlockedPhones";

//Сообщения поддержки
import MessagesList from "./components/pages/MessagesList/MessagesList";
import MessageInfo from "./components/pages/MessageInfo/MessageInfo";
import CreateMessage from "./components/pages/CreateMessage/CreateMessage";
import EditMessage from "./components/pages/EditMessage/EditMessage";

//Вопросы поддержки
import QuestionsList from "./components/pages/QuestionsList/QuestionsList";
import QuestionInfo from "./components/pages/QuestionInfo/QuestionInfo";
import CreateQuestion from "./components/pages/CreateQuestion/CreateQuestion";
import EditQuestion from "./components/pages/EditQuestion/EditQuestion";

//Локализации
import LocalizationsList from "./components/pages/LocalizationsList/LocalizationsList";

//Служебные страницы
import PageNotFound from "./components/pages/PageNotFound/PageNotFound";
import LicenseInfo from "./components/pages/LicenseInfo/LicenseInfo";

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({

});

class App extends Component {

  render() {
    return (
      <Switch>
        <Route exact path='/' component={LoginPage} />
        <Route path='/license' component={LicenseInfo} />
        <Layout>
          <Switch>
            <Route path='/clients' component={ClientsList} />
            <Route path='/consultants' component={ConsultantsList} />
            <Route path='/consultant/:id' component={ConsultantInfo} />

            <Route path='/polls' component={PollsList} />
            <Route path='/poll/:pollId' component={PollInfo} />
            <Route path='/create-poll' component={CreatePoll} />
            <Route path='/edit-poll/:pollId' component={EditPoll} />

            <Route path='/templates' component={TemplatesList} />
            <Route path='/template/:templateId' component={TemplateInfo} />
            <Route path='/create-template' component={CreateTemplate} />
            <Route path='/edit-template/:templateId' component={EditTemplate} />

            <Route path='/analytics' component={Analytics} />
            <Route path='/blocked-phones' component={BlockedPhones} />

            <Route path='/messages' component={MessagesList} />
            <Route path='/message/:msgId' component={MessageInfo} />
            <Route path='/create-message' component={CreateMessage} />
            <Route path='/edit-message/:msgId' component={EditMessage} />

            <Route path='/questions' component={QuestionsList} />
            <Route path='/question/:questionId' component={QuestionInfo} />
            <Route path='/create-question' component={CreateQuestion} />
            <Route path='/edit-question/:questionId' component={EditQuestion} />

            <Route path='/localizations' component={LocalizationsList} />

            <Route path='*' component={PageNotFound} />
          </Switch>
        </Layout>
      </Switch>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
